import {Box, HStack, Text, VStack} from '@chakra-ui/react'
import type {Permission} from '@cypro/engine/utils'
import {DataSection} from '@cypro/ui/components/ui/data-section'
import {useTranslate} from '@tolgee/react'
import {LuCheck, LuMinus} from 'react-icons/lu'

// Permissions grouped the same way as the Permissions plan (section 4).
export const PERMISSION_AREAS: readonly {id: string; permissions: readonly Permission[]}[] = [
  {
    id: 'patients_and_prescriptions',
    permissions: [
      'patients.edit',
      'prescriptions.edit',
      'prescriptions.validate_doctor',
      'prescriptions.validate_pharmacist',
      'prescriptions.approve_budget',
      'prescriptions.patient_arrival',
      'administration.administer',
    ],
  },
  {
    id: 'production_and_stock',
    permissions: ['production.access', 'production.produce', 'production.release', 'stock.manage'],
  },
  {
    id: 'catalogue_and_protocols',
    permissions: ['catalogue.view', 'catalogue.manage', 'basic_data.manage', 'protocols.view', 'protocols.manage'],
  },
  {
    id: 'organisation_and_interfaces',
    permissions: ['organisation.manage', 'interfaces.manage'],
  },
  {
    id: 'reports',
    permissions: ['reports.view', 'reports.identifiers'],
  },
  {
    id: 'administration',
    permissions: ['users.manage', 'settings.manage', 'logs.view'],
  },
]

export function PermissionList({granted}: {granted: ReadonlySet<Permission>}) {
  const {t} = useTranslate('user-groups')

  return (
    <VStack align="stretch" gap="6" width="100%">
      {PERMISSION_AREAS.map(area => (
        <DataSection key={area.id} label={t(`permission_area.${area.id}`)}>
          <VStack align="stretch" gap="3">
            {area.permissions.map(permission => (
              <HStack key={permission} justifyContent="space-between" alignItems="flex-start" gap="4">
                <Box>
                  <Text fontSize="sm" fontWeight="medium">
                    {t(`permission.${permission}.name`)}
                  </Text>
                  <Text fontSize="xs" color="fg.muted">
                    {t(`permission.${permission}.description`)}
                  </Text>
                </Box>
                {granted.has(permission) ? (
                  <LuCheck aria-label={t('permission_granted')} color="var(--chakra-colors-fg-success)" />
                ) : (
                  <LuMinus aria-label={t('permission_not_granted')} color="var(--chakra-colors-fg-muted)" />
                )}
              </HStack>
            ))}
          </VStack>
        </DataSection>
      ))}
    </VStack>
  )
}
